import { createAsyncAction } from "typesafe-actions";
import { LoginRequest } from "../../models/auth/login/LoginRequest";
import { LoginResponse } from "../../models/auth/login/LoginResponse";
import { GetIsAuthenticatedActionTypes, LoginActionTypes, LogoutActionTypes } from "./types";

export const loginActions = createAsyncAction(
    LoginActionTypes.REQUEST,
    LoginActionTypes.SUCCESS,
    LoginActionTypes.ERROR
)<LoginRequest, LoginResponse, undefined>();

export const logoutActions = createAsyncAction(
    LogoutActionTypes.REQUEST,
    LogoutActionTypes.SUCCESS,
    LogoutActionTypes.ERROR
)<undefined, undefined, undefined>();

export const getIsAuthenticatedActions = createAsyncAction(
    GetIsAuthenticatedActionTypes.REQUEST,
    GetIsAuthenticatedActionTypes.SUCCESS,
    GetIsAuthenticatedActionTypes.ERROR
)<undefined, undefined, undefined>();
